<template>
  <div v-if="submission" class="modal fade show d-block" tabindex="-1" style="display: block; z-index: 1050;">
    <div class="modal-dialog" role="document" :style="modalStyle">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title">配置通道</h5>
          <!--<button type="button" class="close" @click="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>-->
        </div>

        <!-- Modal Body -->
        <div class="modal-body">          
          <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">商户信息</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">老板资料</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">激活码</th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="d-flex px-2 py-1">
                      <div>
                        <soft-avatar :img="img1" size="sm" border-radius="lg" class="me-3" alt="user1"/>
                      </div>
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{ merchId }}</h6>
                        <p class="text-xs text-secondary mb-0">{{ merchName }}</p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <p class="text-xs font-weight-bold mb-0">{{ phoneNo }}</p>
                    <p class="text-xs text-secondary mb-0">{{ nickName }}</p>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <soft-input  v-model="code" id="code" placeholder="输入激活码"></soft-input>
                  </td>
                </tr>
              </tbody>
            </table>         
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <soft-button color="warning" @click="activate(merchId, code, submission)">激活</soft-button>
          <soft-button @click="close">关闭</soft-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
//import SoftBadge from "@/components/SoftBadge.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftInput from "@/components/SoftInput.vue";
import img1 from "../../assets/img/team-2.jpg";
import img2 from "../../assets/img/team-3.jpg";
import img3 from "../../assets/img/team-4.jpg";
import img4 from "../../assets/img/team-3.jpg";
import img5 from "../../assets/img/team-2.jpg";
import img6 from "../../assets/img/team-4.jpg";
import { getmerchbyid, activateUpay, getUpayActivatedInfo } from "@/api/merch"
import { getuserinfobydeliverid } from "@/api/user"

export default {
  name: "ChanelConfig",
  data() {
    return {
      img1,
      img2,
      img3,
      img4,
      img5,
      img6,
      modalStyle: {
        left: "50%",  // Default left position
        top: "50%",   // Default top position
        transform: "translate(-50%, -50%)", // Center the modal
        position: "absolute",
        maxWidth: "800px", // You can adjust this as needed
        width: "100%", // Ensuring the modal takes the full width of the container
      },
      merchId: 0,
      merchName: "",
      phoneNo: "",
      nickName: "",
      code: "",
    }
  },
  components: {
    SoftAvatar,
    //SoftBadge,
    SoftButton,
    SoftInput,
  },
  props: {
    submission: {
      type: Object,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("close"); // Emit a close event to the parent
    },

    // Method to update modal position dynamically
    updateModalPosition() {
      // Get the window width and height
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // Calculate the modal position (centered)
      this.modalStyle.left = `${windowWidth / 2}px`;
      this.modalStyle.top = `${windowHeight / 2}px`;
    },

    async fetchData() {
      try{
        const merchData = await getmerchbyid({
            deliver_id: this.submission.deliver_id
          })
        console.log("merch:", merchData)
        if (merchData.code === 0 && merchData.desc) {
          this.merchId = merchData.desc.id 
          this.merchName = merchData.desc.name
        }
        const userData = await getuserinfobydeliverid({
          deliver_id: this.submission.deliver_id
        })
        console.log("user:", userData)
        if (userData.code === 0 && userData.desc) {
          this.phoneNo = userData.desc.Mobile
          this.nickName = userData.desc.NickName
        } 
      }catch(error){
        console.log("initial data err:", error)
      }
    },

    async activate(merchId, code, submission) {
      const activatedInfo = await getUpayActivatedInfo({
        info_id: submission.info_id
      })
      if (activatedInfo.code === 0){
        alert('此资料已经通过申请并已经激活')
        return
      }
      console.log("info_id:", submission.info_id, "deliverid:", merchId, "code:", this.code)
      const resp = await activateUpay({
        info_id: submission.info_id,
        deliver_id: merchId,
        code: this.code
      })
      console.log(resp)
      if (resp.desc) {
        alert(resp.desc)
      }
    }

  },

  mounted() {
    console.log(this.submission)
    //获取相关信息
    this.fetchData()
    // Update the modal position when component is mounted
    this.updateModalPosition();

    // Optionally, update the position on window resize
    window.addEventListener('resize', this.updateModalPosition);
  },

  beforeUnmount() {
    // Clean up the event listener when the component is destroyed
    window.removeEventListener('resize', this.updateModalPosition);
  }
};
</script>

<style scoped>
.modal {
  display: block; /* Ensure modal is visible */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Gray background to cover the entire page */
  z-index: 1050;
}

.modal-dialog {
  position: absolute; /* This makes sure the modal is positioned absolutely */
  max-width: 800px;
  width: 100%; /* Ensuring that modal dialog takes full width within the container */
}

.modal-content {
  background-color: white;
  border-radius: 4px;
}

.modal-header {
  background-color: #f8f9fa;
}

.modal-body {
  padding: 1rem;
}

.modal-footer {
  padding: 0.75rem;
  text-align: right;
}
</style>
